export default __webpack_public_path__ + "227356c1bb9e5ce2a2b12d65ce19e971.png";